module.exports = "/_next/static/resources/single-4d97c9e578b8eda0b5111bcb93672a14.jpg";